export default "__VITE_ASSET__1WyiY_Cd__"